import { ApolloClient,ApolloLink , HttpLink } from '@apollo/client';
import GetApacheCache from './apolloCache';
import { onError } from '@apollo/client/link/error';
const { getConfig } = require('../intl/followupc');

export default function GetApolloClient(cacheList) {
  const httpLink = new HttpLink({
    uri: getConfig("REACT_APP_DATA_ENDPOINT"),
    credentials: "include",
  })
  return new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors }) => {
        if (graphQLErrors[0]?.extensions?.code === "FORBIDDEN"
          && graphQLErrors?.[0]?.message?.search("Authentication Failed")  !== -1
        ){
            window.alert("Session Expired!!! Please Login Again...")
            sessionStorage?.clear();
            location.replace(getConfig("REACT_FRONTEND_URL"));
        }
      }),
      httpLink
     ]),
    cache: GetApacheCache(cacheList),
    credentials: 'include',
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });
}
